require('./manageScoringRules.i18n.json');
require('./manageScoringRules.tpl.html');
require('./manageScoringRulesRepository.js');
require('./refreshModal.tpl.html');
require('./refreshModalController.js');
require('./refreshModal.less');

/*@ngInject*/
const ManageScoringRulesController = function ($scope, $rootScope, $stateParams, $uibModal, scoringRulesEditorModel, coreConstant, localization, configurationConstant, dateUtil, configurationMediator, fieldType, dataSetUtil, $timeout, dataSetType, xmlUtil, authorizationConstants, currentUserModel) {

    let translations,
        timeoutList = [];

    $scope.viewModel = {
        name: '',
        namePrompt: '',
        category: '',
        categoryPrompt: '',
        effectiveDateRange: '',
        effectiveDateRangeStart: null,
        effectiveStartDatePrompt: null,
        effectiveDateRangeEnd: '',
        effectiveEndDatePrompt: '',
        formName: '',
        variableName: '',
        selectorWidgetMode: 'forms',
        form: {name: '', variableName: ''},
        endDateValidationErrorMessage: null,
        fieldValidator: null,
        fieldValueScoringList: [],
        categoryList: [],
        selectedCategory: '',
        filteredCategoryItemsList: [],
        minPrompt: '',
        maxPrompt: '',
        valuePrompt: '',
        scorePrompt: '',
        showRefresh: false,
        dataSetItems: [],
        applyScoring: 'always',
        operators: [],
        selectedOperator: '',
        selectOperatorPrompt: '',
        triggerForm: {name: '', variableName: ''},
        multiStepComponentName: 'triggerForm',
        inputFormField: 'inputFormField',
        isDataSetField: false,
        triggerDataSetList: [],
        itemName: 'dataSetList',
        selectedDataSet: [],
        selectedTriggerDataSetValues: [],
        selectDataSetPrompt: '',
        triggerFieldValue: '',
        showApplyScoring: false,
        populatedScoringFormulas: [],
        emptyObj: {value: '', score: '', min: '', max: '', isValid: true},
        showInputFormField: false,
        formFieldDataSets: [],
        addValuePrompt: '',
        dateInitialized: false,
        hasManagePermission: currentUserModel.hasAuthorization(authorizationConstants.MODIFY_CONFIG_SCORING),
        classCodeMockFieldStructure: {
            uiField: null,
            fieldModel: {
                value: []
            },
            dynamicProperties: {}
        },
        classCodeMockEffectiveDate: new Date(),
        isClassCodePicker: false,
        showClassCode: false,
        selectedClassCodesValues: '',
        flags: '',
        flagsPrompt: ''
    };

    localization.getTranslationByKey('manageScoringRules').then(function (result) {
        translations = result;
        $scope.viewModel.namePrompt = _.get(translations, 'namePrompt');
        $scope.viewModel.categoryPrompt = _.get(translations, 'categoryPrompt');
        $scope.viewModel.effectiveStartDatePrompt = _.get(translations, 'effectiveStartDatePrompt');
        $scope.viewModel.effectiveEndDatePrompt = _.get(translations, 'effectiveEndDatePrompt');
        $scope.viewModel.inputFormFieldPrompt = _.get(translations, 'inputFormFieldPrompt');
        $scope.viewModel.endDateValidationErrorMessage = _.get(translations, 'endDateValidationErrorMessage');
        $scope.viewModel.minPrompt = _.get(translations, 'minPrompt');
        $scope.viewModel.maxPrompt = _.get(translations, 'maxPrompt');
        $scope.viewModel.valuePrompt = _.get(translations, 'valuePrompt');
        $scope.viewModel.scorePrompt = _.get(translations, 'scorePrompt');
        $scope.viewModel.selectOperatorPrompt = _.get(translations, 'selectOperatorPrompt');
        $scope.viewModel.selectDataSetPrompt = _.get(translations, 'selectDataSetPrompt');
        $scope.viewModel.inputFormFieldErrorMessage = _.get(translations, 'inputFormFieldErrorMessage');
        $scope.viewModel.warningLabel = _.get(translations, 'warningLabel');
        $scope.viewModel.warningMessage = _.get(translations, 'warningMessage');
        $scope.viewModel.deleteAll = _.get(translations, 'deleteAll');
        $scope.viewModel.doNotDelete = _.get(translations, 'doNotDelete');
        $scope.viewModel.addValuePrompt = _.get(translations, 'addValuePrompt');
        $scope.viewModel.flagsPrompt = _.get(translations, 'flagsPrompt');

        $scope.viewModel.operators = [{name: _.get(translations, 'isInList'), value: 0},
            {name: _.get(translations, 'contains'), value: 1}, {name: _.get(translations, 'matches'), value: 2}];

        init();
    });


    function loadCategoryList() {
        dataSetUtil.getDataSet({name: 'Scoring Rule Folders'}).then(function (dataset) {
            $scope.viewModel.categoryList = dataset.items;
        });
    }


    function init() {
        $scope.viewModel.fieldValueScoringList = [];
        scoringRulesEditorModel.buildScoringRule(_.isEmpty($stateParams.scoringRuleId) ? -1 : $stateParams.scoringRuleId);
    }

    function fillScoringInputGrid() {
        let fieldValue = {};
        $scope.viewModel.fieldValueScoringList = [];
        $scope.viewModel.populatedScoringFormulas = [];
        configurationMediator.findUIFieldByUIFormTemplateUniqueNameAndFieldName($scope.viewModel.scoringRule.formTemplateUniqueName, $scope.viewModel.scoringRule.variableName).then(function (uiField) {
            if (isFieldWithoutValidatorAndDataset(uiField)
                || uiField.fieldTemplate.validator === 'number'
                || uiField.fieldTemplate.validator === 'percent'
                || uiField.fieldTemplate.validator === 'currency'
                || uiField.fieldTemplate.validator === 'number with commas'
                || uiField.fieldTemplate.validator === 'number range') {
                $scope.fieldValidator = 'numberValidator';
                _.each($scope.viewModel.scoringRule.formulas, function (formula) {
                    fieldValue = {};
                    fieldValue.type = 'Range';
                    fieldValue.id = formula.id;
                    fieldValue.min = !_.isNil(formula.minValue) ? formula.minValue : '';
                    fieldValue.max = !_.isNil(formula.maxValue) ? formula.maxValue : '';
                    fieldValue.score = !_.isNil(formula.score) ? formula.score : '';

                    if (isMinMaxValid(fieldValue)) {
                        fieldValue.isValid = true;
                    } else {
                        fieldValue.isValid = false;
                    }
                    $scope.viewModel.populatedScoringFormulas.push(fieldValue);
                });
                $scope.viewModel.fieldValueScoringList = _.map($scope.viewModel.populatedScoringFormulas, _.clone);
                $scope.viewModel.fieldValueScoringList.push(getEmptyObj());
            } else {
                if (uiField.fieldTemplate.type === fieldType.CHECK_BOX || uiField.fieldTemplate.type === fieldType.YES_NO) {
                    _.each($scope.viewModel.scoringRule.formulas, function (formula) {
                        fieldValue = {};
                        fieldValue.type = 'Discrete';
                        fieldValue.id = formula.id;
                        fieldValue.value = !_.isNil(formula.value) ? formula.value : '';
                        fieldValue.score = !_.isNil(formula.score) ? formula.score : '';
                        if (_.isEmpty(String(fieldValue.value)) && _.isEmpty(String(fieldValue.score))) {
                            fieldValue.isValid = false;
                        } else if (!_.isEmpty(String(fieldValue.value)) && _.isEmpty(String(fieldValue.score))) {
                            fieldValue.isValid = true;
                        } else if (!_.isEmpty(String(fieldValue.value)) && !_.isEmpty(String(fieldValue.score))) {
                            fieldValue.isValid = true;
                        } else {
                            fieldValue.isValid = false;
                        }

                        $scope.viewModel.fieldValueScoringList.push(fieldValue);
                    });
                } else {
                    if (!_.isEmpty(uiField.fieldTemplate.dataSetName)) {
                        fillRefreshDataset(uiField.fieldTemplate.dataSetName);

                    }
                    _.each($scope.viewModel.scoringRule.formulas, function (formula) {
                        fieldValue = {};
                        fieldValue.type = 'Discrete';
                        fieldValue.id = formula.id;
                        fieldValue.value = !_.isNil(formula.value) ? formula.value : '';
                        fieldValue.score = !_.isNil(formula.score) ? formula.score : '';

                        if (_.isEmpty(String(fieldValue.value)) && _.isEmpty(String(fieldValue.score))) {
                            fieldValue.isValid = false;
                        } else if (!_.isEmpty(String(fieldValue.value)) && _.isEmpty(String(fieldValue.score))) {
                            fieldValue.isValid = true;
                        } else if (!_.isEmpty(String(fieldValue.value)) && (!_.isEmpty(String(fieldValue.score)))) {
                            fieldValue.isValid = true;
                        } else {
                            fieldValue.isValid = false;
                        }
                        $scope.viewModel.populatedScoringFormulas.push(fieldValue);
                    });
                    $scope.viewModel.fieldValueScoringList = _.map($scope.viewModel.populatedScoringFormulas, _.clone);
                }

                $scope.viewModel.fieldValueScoringList.push(getEmptyObj());
            }
        });

        function fillRefreshDataset(dataSetName) {
            let dataSetParams = {name: dataSetName};
            $scope.viewModel.showRefresh = false;
            if (dataSetUtil.getDataSetType(dataSetParams.name) !== dataSetType.REPEATING_FORM && dataSetUtil.getDataSetType(dataSetParams.name) !== dataSetType.CUSTOM) {
                dataSetUtil.getDataSet(dataSetParams).then((result) => {
                    let fieldValue = {};

                    _.each(result.items, function (formula) {
                        fieldValue = {};
                        fieldValue.type = 'Discrete';
                        fieldValue.id = formula.id;
                        fieldValue.value = !_.isNil(formula.value) ? formula.value : '';
                        fieldValue.score = !_.isNil(formula.score) ? formula.score : '';
                        if (_.isEmpty(String(fieldValue.value)) && _.isEmpty(String(fieldValue.score))) {
                            fieldValue.isValid = false;
                        } else if (!_.isEmpty(String(fieldValue.value)) && _.isEmpty(String(fieldValue.score))) {
                            fieldValue.isValid = true;
                        } else if (!_.isEmpty(String(fieldValue.value)) && (!_.isEmpty(String(fieldValue.score)))) {
                            fieldValue.isValid = true;
                        } else {
                            fieldValue.isValid = false;
                        }
                        $scope.viewModel.formFieldDataSets.push(fieldValue);
                    });
                    $scope.viewModel.showRefresh = true;
                });
            }
        }

        $scope.viewModel.populatedScoringFormulas.sort(function (item1, item2) {
            let item1Value = item1.value.toUpperCase();
            let item2Value = item2.value.toUpperCase();
            if (item1Value < item2Value) {
                return -1;
            }
            if (item1Value > item2Value) {
                return 1;
            }
            return 0;
        });
    }

    $scope.onItemChange = function () {
        let formulas = [];
        $scope.formulasValid = true;

        _.each($scope.viewModel.fieldValueScoringList, function (formula) {
            let newFormula = {};
            if ($scope.fieldValidator === 'numberValidator') {

                if (isMinMaxValid(formula)) {
                    newFormula.type = 'Range';
                    if (!_.isNaN(parseInt(formula.min))) {
                        newFormula.minValue = parseInt(formula.min);
                    }
                    if (!_.isNaN(parseInt(formula.max))) {
                        newFormula.maxValue = parseInt(formula.max);
                    }
                    if (!_.isNaN(parseInt(formula.score))) {
                        newFormula.score = parseInt(formula.score);
                    }

                    if (parseFloat(formula.min) > parseFloat(formula.max)) {
                        $scope.formulasValid = false;
                    }
                    formulas.push(newFormula);
                } else {
                    if (!(_.isEmpty(String(formula.min)) && _.isEmpty(String(formula.max)) && _.isEmpty(String(formula.score)))) {
                        $scope.formulasValid = false;
                    }
                }
            } else {
                if (_.isEmpty(String(formula.value)) && _.isEmpty(String(formula.score))) {
                    return;
                }
                newFormula.type = 'Discrete';
                if (!_.isEmpty(formula.value)) {
                    newFormula.value = formula.value;
                }
                if (!_.isNaN(parseInt(formula.score))) {
                    newFormula.score = parseInt(formula.score);
                }

                if (_.isEmpty(String(formula.value)) && !_.isEmpty(String(formula.score))) {
                    $scope.formulasValid = false;
                }

                formulas.push(newFormula);
            }
        });

        $scope.viewModel.scoringRule.formulas = formulas;

        $scope.handleChange();

    };

    function fillScoringFormulasWithDataSet() {
        let formulas = [];
        $scope.formulasValid = true;

        if ($scope.fieldValidator !== 'numberValidator' && !_.isNil($scope.viewModel.scoringRule.formTemplateUniqueName) && !_.isNil($scope.viewModel.scoringRule.variableName)) {
            configurationMediator.findUIFieldByUIFormTemplateUniqueNameAndFieldName($scope.viewModel.scoringRule.formTemplateUniqueName, $scope.viewModel.scoringRule.variableName).then((uiField) => {
                if (!_.isEmpty(uiField.fieldTemplate.dataSetName)) {
                    let dataSetParams = {name: uiField.fieldTemplate.dataSetName};
                    if (dataSetUtil.getDataSetType(dataSetParams.name) !== dataSetType.REPEATING_FORM && dataSetUtil.getDataSetType(dataSetParams.name) !== dataSetType.CUSTOM) {
                        dataSetUtil.getDataSet(dataSetParams).then((result) => {
                            _.each(result.items, function (formula) {
                                let newFormula = {};
                                newFormula.type = 'Discrete';
                                newFormula.id = formula.id;
                                newFormula.value = !_.isNil(formula.value) ? formula.value : '';
                                newFormula.score = !_.isNil(formula.score) ? formula.score : '';
                                formulas.push(newFormula);
                            });

                        });
                    }
                }
            });

            $scope.viewModel.scoringRule.formulas = formulas;
        }
    }

    $scope.onOperatorChange = function (operator) {
        let isInList = _.get(translations, 'isInList');
        $scope.viewModel.scoringRule.triggerFieldValue = '';
        $scope.viewModel.selectedOperator = operator;
        $scope.viewModel.scoringRule.triggerOperator = operator.value;

        if (operator.name === isInList) {
            if ($scope.viewModel.isClassCodePicker) {
                configurationMediator.findUIFieldByUIFormTemplateUniqueNameAndFieldName($scope.viewModel.scoringRule.triggerFieldFormTemplateUniqueName, $scope.viewModel.scoringRule.triggerFieldVariableName).then((uiField) => {
                    $scope.viewModel.classCodeMockFieldStructure.uiField = uiField;
                    $scope.viewModel.classCodeMockFieldStructure.fieldModel.value = [];
                    $scope.viewModel.selectedTriggerDataSetValues = null;
                    $scope.viewModel.showClassCode = true;
                    $rootScope.$broadcast(coreConstant.event.RELOAD_CLASS_CODE_MULTI_SELECT);
                });
            }
            $scope.viewModel.isDataSetField = $scope.viewModel.triggerDataSetList.length > 0;
        } else {
            $scope.viewModel.showClassCode = false;
            $scope.viewModel.isDataSetField = false;
            $scope.viewModel.selectedDataSet = [];
        }
    };

    $scope.onDataSetChange = function (dataSet) {
        $scope.viewModel.selectedDataSet = dataSet;
    };

    $scope.getOperator = function () {
        if (!_.isNil($scope.viewModel.selectedOperator) && $scope.viewModel.selectedOperator !== '') {
            return $scope.viewModel.selectedOperator.name;
        }
        return $scope.viewModel.selectOperatorPrompt;
    };

    $scope.getDataSet = function (item) {
        return $scope.viewModel.selectedDataSet = item;
    };

    $scope.filterItems = function (searchText) {
        let filteredItemsList = [],
            newValueMatch;

        if (!_.isEmpty(searchText)) {
            filteredItemsList = _.filter($scope.viewModel.categoryList, function (item) {
                return _.includes(item.name.toLowerCase(), searchText.toLowerCase());
            });

            // Add the new value to the filtered list if the searchText entered does not match anything in
            // the current list
            newValueMatch = _.find(filteredItemsList, function (item) {
                return item.name.toLowerCase() === searchText.toLowerCase();
            });
            if (_.isNil(newValueMatch)) {
                filteredItemsList.push({
                    name: searchText,
                    value: searchText,
                    isCreateNew: true
                });
            }
        } else {
            filteredItemsList = $scope.viewModel.categoryList;
        }
        $scope.viewModel.filteredCategoryItemsList = filteredItemsList;
    };

    $scope.handleSelect = function () {
        if ($scope.viewModel.selectedCategory && $scope.viewModel.selectedCategory.isCreateNew) {
            $scope.viewModel.selectedCategory.isCreateNew = false;
            $scope.viewModel.categoryList.push($scope.viewModel.selectedCategory);
            $scope.viewModel.filteredCategoryItemsList = $scope.viewModel.categoryList;
        }
        $scope.handleChange();
    };

    $scope.dateRangeUpdated = function (value) {
        let dateArray = _.split(value, '::');
        if (dateArray[1] !== ' ' && dateArray[0] !== 'ALL') {
            $scope.viewModel.scoringRule.effectiveDateRangeBegin = moment.utc(dateArray[1].split('+')[0]);
        } else {
            $scope.viewModel.scoringRule.effectiveDateRangeBegin = null;
        }
        if (dateArray[0] !== 'ALL') {
            $scope.viewModel.scoringRule.effectiveDateRangeEnd = moment.utc(dateArray[2].split('+')[0]);
        } else {
            $scope.viewModel.scoringRule.effectiveDateRangeEnd = null;
        }

        if (dateUtil.isBefore($scope.viewModel.scoringRule.effectiveDateRangeEnd, $scope.viewModel.scoringRule.effectiveDateRangeBegin)) {
            $scope.viewModel.scoringRule.effectiveDateRangeEnd = null;
        }
        if ($scope.viewModel.dateInitialized === false) {
            $scope.viewModel.dateInitialized = true;
        } else {
            $scope.handleChange();
        }

    };

    $scope.onTextInputFocused = function (event) {
        unSelectAllRow();
    };

    $scope.valueScoreItemBlur = function (event, item) {
        if ($scope.fieldValidator === 'numberValidator') {
            $scope.rangeItemBlur(event, item);
        } else {
            if (_.isEmpty(String(item.value)) && _.isEmpty(String(item.score))) {
                item.isValid = true;
            } else {
                if (item.value !== '-') {
                    if ($scope.viewModel.fieldValueScoringList.length > 1) {

                        let valueArray = [],
                            matchValueArray = [];

                        _.each($scope.viewModel.fieldValueScoringList, function (fieldValue) {
                            if (_.isEmpty(String(fieldValue.value)) && _.isEmpty(String(fieldValue.score))) {
                                fieldValue.isValid = true;
                            } else if (_.isEmpty(String(fieldValue.value)) && !_.isEmpty(String(fieldValue.score))) {
                                fieldValue.isValid = false;
                            } else {
                                if (valueArray.length !== 0 && valueArray.indexOf(fieldValue.value) !== -1) {
                                    matchValueArray.push(fieldValue.value);
                                } else {
                                    valueArray.push(fieldValue.value);
                                }
                                fieldValue.isValid = true;
                            }
                        });

                        _.each(matchValueArray, function (value) {
                            _.each($scope.viewModel.fieldValueScoringList, function (fieldValue) {
                                if (value === fieldValue.value && !_.isEmpty(fieldValue.value)) {
                                    fieldValue.isValid = false;
                                }
                            });
                        });
                    } else {
                        item.isValid = true;
                    }

                } else {
                    item.isValid = false;
                }
            }
        }
        if (allFieldValueScoringListItemsValid()) {
            removeEmptyLastRows();
            $scope.viewModel.fieldValueScoringList.push(getEmptyObj());
        }
        $scope.onItemChange();
    };

    $scope.rangeItemBlur = function (event, item) {
        item.tooltip = '';

        if ((_.isEmpty(String(item.min)) && _.isEmpty(String(item.max)) && _.isEmpty(String(item.score)))) {
            return true;
        }

        if (isMinMaxValid(item)) {
            if (!_.isEmpty(String(item.min)) && !_.isEmpty(String(item.max))) {
                if (parseFloat(item.min) > parseFloat(item.max)) {
                    $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, _.get(translations, 'rangeValidationMessage'));
                    item.isValid = false;
                    item.tooltip = _.get(translations, 'rangeValidationMessage');
                } else {
                    if (_.isEmpty(String(item.score))) {
                        item.isValid = false;
                    } else {
                        item.isValid = true;
                    }
                }
            } else {
                item.isValid = true;
            }
        } else {
            item.isValid = false;
        }
        $scope.onItemChange();
    };

    function isMinMaxValid(item) {
        if (!_.isEmpty(String(item.min)) && !_.isEmpty(String(item.max)) && !_.isEmpty(String(item.score))) {
            return true;
        } else if ((_.isEmpty(String(item.min)) && !_.isEmpty(String(item.max)) && !_.isEmpty(String(item.score))) || (!_.isEmpty(String(item.min)) && _.isEmpty(String(item.max)) && !_.isEmpty(String(item.score)))) {
            return true;
        }
        return false;
    }


    $scope.addItem = function (event, item) {
        let items = [];
        if (!isEmptyDataItem(item)) {
            _.each($scope.viewModel.fieldValueScoringList, function (fieldValueScoring) {
                if (!isEmptyDataItem(fieldValueScoring)) {
                    items.push(fieldValueScoring);
                }
            });
            $scope.viewModel.fieldValueScoringList = items;
        }

        if (allFieldValueScoringListItemsValid()) {
            removeEmptyLastRows();
            $scope.viewModel.fieldValueScoringList(getEmptyObj());
        }
    };

    function allFieldValueScoringListItemsValid() {
        let result = true,
            isEmptyRowExist = false;
        _.each($scope.viewModel.fieldValueScoringList, function (fieldValueScoring) {
            if (isEmptyDataItem(fieldValueScoring)) {
                isEmptyRowExist = true;
            }
            if (!fieldValueScoring.isValid) {
                result = false;
            }
        });
        if (!isEmptyRowExist && result) {
            return true;
        }
        return false;
    }

    function unSelectAllRow() {
        _.each($scope.viewModel.fieldValueScoringList, function (fieldValue) {
            fieldValue.selected = false;
        });
    }

    $scope.onScoringItemSelected = function (event, item) {
        if ($scope.viewModel.fieldValueScoringList.length > 1) {
            if (event.ctrlKey) {
                item.selected = !item.selected;
            } else if (event.shiftKey) {
                item.selected = true;
            } else {
                unSelectAllRow();
                if ($scope.fieldValidator === 'numberValidator') {
                    if (_.isEmpty(String(item.min)) && _.isEmpty(String(item.max)) && _.isEmpty(String(item.score))) {
                        item.selected = false;
                    } else {
                        item.selected = true;
                    }
                } else {
                    if (_.isEmpty(String(item.value)) && _.isEmpty(String(item.score))) {
                        item.selected = false;
                    } else {
                        item.selected = true;
                    }
                }
            }
        }
    };

    $scope.onFieldKeyPress = function ($event) {
        let keyCode = $event.which || $event.keyCode;
        if (!isMinus(keyCode) && !isDecimal(keyCode) && !isBackspace(keyCode) && !isTab(keyCode) && isOutOfRange(keyCode)) {
            $event.preventDefault();
        }
    };

    $scope.onScoreKeyPress = function ($event) {
        let keyCode = $event.which || $event.keyCode;
        if (!isMinus(keyCode) && !isBackspace(keyCode) && !isTab(keyCode) && isOutOfRange(keyCode)) {
            $event.preventDefault();
        }
    };

    function isMinus(keyCode) {
        return keyCode === 45;
    }

    function isDecimal(keyCode) {
        return keyCode === 46;
    }

    function isBackspace(keyCode) {
        return keyCode === 8;
    }

    function isTab(keyCode) {
        return keyCode === 9;
    }

    function isOutOfRange(keyCode) {
        return (keyCode < 48 || keyCode > 57);
    }

    $scope.handleDeleteKeyEventAction = function () {
        let result = false,
            emptyRowPresent = false;
        timeoutList.push($timeout(function () {
            _.remove($scope.viewModel.fieldValueScoringList, function (fieldValue) {
                if (fieldValue.selected) {
                    result = true;
                    return result;
                }
            });

            if (result) {
                _.each($scope.viewModel.fieldValueScoringList, function (fieldValue) {
                    if (isEmptyDataItem(fieldValue)) {
                        emptyRowPresent = true;
                    }
                });
                if (!emptyRowPresent) {
                    $scope.viewModel.fieldValueScoringList.push(getEmptyObj());
                }
                $scope.onItemChange();
            }
        }), 0);
    };

    function isEmptyDataItem(item) {
        if ($scope.fieldValidator === 'numberValidator') {
            return _.isEmpty(String(item.min)) && _.isEmpty(String(item.max)) && _.isEmpty(String(item.score));
        } else {
            return _.isEmpty(String(item.value)) && _.isEmpty(String(item.score));
        }
    }

    function removeEmptyLastRows() {
        _.remove($scope.viewModel.fieldValueScoringList, function (fieldValueScoring) {
            return isEmptyDataItem(fieldValueScoring);
        });
    }

    $scope.$on(configurationConstant.event.SCORING_RULE_UPDATED, function (event, scoringRuleId) {
        let scoringRule = scoringRulesEditorModel.getScoringRule(scoringRuleId);
        $scope.viewModel.scoringRule = scoringRule;
        if (parseInt(scoringRuleId) !== -1 && !$scope.viewModel.dateInitialized) {
            dataSetUtil.getDataSet({name: 'Scoring Rule Folders'}).then(function (dataset) {
                $scope.viewModel.categoryList = dataset.items;
                _.each($scope.viewModel.categoryList, function (category) {
                    if (parseInt(category.value) === scoringRule.scoringFolderId) {
                        $scope.viewModel.selectedCategory = category;
                    }
                });
            });


            if (!_.isNil(scoringRule.effectiveDateRangeBegin) || !_.isNil(scoringRule.effectiveDateRangeEnd)) {
                $scope.viewModel.effectiveDateRange = 'SPECIFIED::';
                if (!_.isNil(scoringRule.effectiveDateRangeBegin)) {
                    $scope.viewModel.effectiveDateRange += dateUtil.formatShortDate(moment.utc(scoringRule.effectiveDateRangeBegin));
                }
                $scope.viewModel.effectiveDateRange += '::';
                if (!_.isNil(scoringRule.effectiveDateRangeEnd)) {
                    $scope.viewModel.effectiveDateRange += dateUtil.formatShortDate(moment.utc(scoringRule.effectiveDateRangeEnd));
                }
            } else {
                $scope.viewModel.dateInitialized = true;
            }

            $timeout(function () {
                $rootScope.$broadcast(coreConstant.event.REFRESH_MULTI_SELECT, $scope.viewModel.scoringRule.formTemplateUniqueName, $scope.viewModel.scoringRule.variableName, $scope.viewModel.inputFormField);
                $rootScope.$broadcast(coreConstant.event.REFRESH_DATE_RANGE);
            }, 100);

            if ($scope.viewModel.scoringRule.formTemplateUniqueName !== '') {
                $scope.viewModel.showInputFormField = true;
            }

            $scope.viewModel.scoringRule.triggerFieldFormTemplateUniqueName = scoringRule.triggerFieldFormTemplateUniqueName;
            $scope.viewModel.scoringRule.triggerFieldVariableName = scoringRule.triggerFieldVariableName;

            $scope.viewModel.selectedDataSet = [];
            if (!_.isNil($scope.viewModel.scoringRule.triggerFieldFormTemplateUniqueName) && $scope.viewModel.scoringRule.triggerFieldFormTemplateUniqueName !== '') {
                let triggerFieldValues = xmlUtil.parseString(scoringRule.triggerFieldValue);
                triggerDataSet($scope.viewModel.scoringRule.triggerFieldFormTemplateUniqueName, $scope.viewModel.scoringRule.triggerFieldVariableName, triggerFieldValues.triggerFieldValue);
                $timeout(function () {
                    $rootScope.$broadcast(coreConstant.event.REFRESH_MULTI_SELECT, $scope.viewModel.scoringRule.triggerFieldFormTemplateUniqueName, $scope.viewModel.scoringRule.triggerFieldVariableName, $scope.viewModel.multiStepComponentName);
                }, 100);
                $scope.viewModel.applyScoring = 'OnConditionMet';
                $scope.viewModel.showApplyScoring = true;

                _.each($scope.viewModel.operators, function (operator) {
                    if (scoringRule.triggerOperator === operator.value) {
                        $scope.viewModel.selectedOperator = operator;
                        if (operator.value === 0) {
                            $scope.viewModel.isDataSetField = true;
                        }
                    }
                });

                $scope.viewModel.selectedTriggerDataSetValues = triggerFieldValues;
                $scope.viewModel.selectedClassCodesValues = _.join(triggerFieldValues.triggerFieldValue, ',');

                if (!$scope.viewModel.isDataSetField && !$scope.viewModel.showClassCode && triggerFieldValues.triggerFieldValue) {
                    $scope.viewModel.triggerFieldValue = triggerFieldValues.triggerFieldValue;
                }
            }
            fillScoringInputGrid();
        }
    });

    $scope.$on(configurationConstant.event.SELECTOR_WIDGET_UPDATED, function (event, item1Name, item2, multiselect, name) {
        updateSelectorWidget(item1Name, item2.fieldName, name);
        $scope.onItemChange();
        $scope.handleChange();
    });

    function triggerDataSet(item1Name, item2Name, selectedDataSets) {
        resetTriggerConditionForm();
        if (_.isEmpty(item1Name)) {
            $scope.viewModel.scoringRule.triggerFieldFormTemplateUniqueName = '';
            $scope.viewModel.scoringRule.triggerFieldVariableName = '';
            $scope.viewModel.classCodeMockFieldStructure.fieldModel.value = [];
            $rootScope.$broadcast(coreConstant.event.RELOAD_CLASS_CODE_MULTI_SELECT);
            return;
        }
        let fieldValue = {};

        $scope.viewModel.selectedDataSet = [];
        $scope.viewModel.isDataSetField = false;
        $scope.viewModel.scoringRule.triggerFieldFormTemplateUniqueName = item1Name;
        $scope.viewModel.scoringRule.triggerFieldVariableName = item2Name;
        $scope.viewModel.triggerDataSetList = [];


        if (!_.isNil($scope.viewModel.scoringRule.triggerFieldFormTemplateUniqueName) && ($scope.viewModel.scoringRule.triggerFieldVariableName)) {
            configurationMediator.findUIFieldByUIFormTemplateUniqueNameAndFieldName(item1Name, item2Name).then((uiField) => {
                if (!_.isEmpty(uiField.fieldTemplate.dataSetName)) {
                    if (!_.isEmpty(uiField.fieldTemplate.dataSetName)) {
                        let dataSetParams = {name: uiField.fieldTemplate.dataSetName};
                        if (dataSetUtil.getDataSetType(dataSetParams.name) !== dataSetType.CUSTOM) {
                            $scope.viewModel.isDataSetField = true;
                            dataSetUtil.getDataSet(dataSetParams).then(function (result) {
                                $scope.viewModel.triggerDataSetList = result.items;
                                if (_.isArray(selectedDataSets)) {
                                    $scope.viewModel.selectedTriggerDataSetValues = selectedDataSets;
                                    $scope.viewModel.selectedDataSet = _.join(selectedDataSets, '::');
                                } else {
                                    $scope.viewModel.selectedTriggerDataSetValues = [selectedDataSets];
                                    $scope.viewModel.selectedDataSet = selectedDataSets;
                                }
                            });
                        }
                    }
                } else {
                    if (uiField.fieldTemplate.type === fieldType.CHECK_BOX) {
                        fieldValue = {};
                        fieldValue.name = _.get(translations, 'true');
                        fieldValue.value = _.get(translations, 'true');
                        $scope.viewModel.triggerDataSetList.push(fieldValue);
                        fieldValue = {};
                        fieldValue.name = _.get(translations, 'false');
                        fieldValue.value = _.get(translations, 'false');
                        $scope.viewModel.triggerDataSetList.push(fieldValue);
                    } else if (uiField.fieldTemplate.type === fieldType.YES_NO) {
                        fieldValue = {};
                        fieldValue.name = _.get(translations, 'yes');
                        fieldValue.value = _.get(translations, 'yes');
                        $scope.viewModel.triggerDataSetList.push(fieldValue);
                        fieldValue = {};
                        fieldValue.name = _.get(translations, 'no');
                        fieldValue.value = _.get(translations, 'no');
                        $scope.viewModel.triggerDataSetList.push(fieldValue);
                    } else if (uiField.fieldTemplate.type === fieldType.CLASSCODEFINDER) {
                        $scope.viewModel.isClassCodePicker = true;
                        if (!_.isNil(selectedDataSets)) {
                            $scope.viewModel.showClassCode = $scope.viewModel.scoringRule.triggerOperator === 0;
                        }

                    } else {
                        if (!_.isNil(selectedDataSets) && selectedDataSets !== '') {
                            $scope.viewModel.triggerFieldValue = selectedDataSets;
                        }
                    }

                    if (!_.isNil(selectedDataSets)) {
                        $scope.viewModel.selectedDataSet = [];
                        if (!_.isObject(selectedDataSets)) {
                            $scope.viewModel.selectedDataSet.push(selectedDataSets);
                        } else {
                            _.each($scope.viewModel.triggerDataSetList, function (triggerDataSet) {
                                _.each(selectedDataSets, function (selectedDataSet) {
                                    if (triggerDataSet.value === selectedDataSet) {
                                        $scope.viewModel.selectedDataSet.push(selectedDataSet);
                                    }
                                });
                            });
                            if ($scope.viewModel.isClassCodePicker) {
                                $scope.viewModel.selectedDataSet = selectedDataSets;
                            }
                        }

                        $scope.viewModel.classCodeMockFieldStructure.uiField = uiField;
                        $scope.viewModel.classCodeMockFieldStructure.fieldModel.value = _.join($scope.viewModel.selectedDataSet, '::,');
                    }
                    $scope.isTriggerRuleValid();
                }
            });
        }
    }

    function updateSelectorWidget(item1Name, item2, name) {
        if (name === $scope.viewModel.inputFormField) {
            $scope.fieldValidator = null;
        }

        if (name === 'triggerForm') {
            $scope.viewModel.selectedDataSet = [];
            $scope.viewModel.classCodeMockFieldStructure.fieldModel.value = null;
            $scope.viewModel.isDataSetField = false;
            triggerDataSet(item1Name, item2);
        } else {
            $scope.viewModel.scoringRule.formTemplateUniqueName = (item1Name !== '' && !_.isNil(item1Name)) ? item1Name : '';
            $scope.viewModel.scoringRule.variableName = (item2 !== '' && !_.isNil(item2)) ? item2 : '';
            $scope.viewModel.fieldValueScoringList = [];


            if (!_.isNil($scope.viewModel.scoringRule.formTemplateUniqueName) && $scope.viewModel.scoringRule.formTemplateUniqueName !== ''
                && !_.isNil($scope.viewModel.scoringRule.variableName) && $scope.viewModel.scoringRule.variableName !== '') {
                fillDataSet(item1Name, item2);
            } else {
                $scope.viewModel.showInputFormField = false;
                $scope.viewModel.showRefresh = false;
            }
        }
    }

    function fillDataSet(item1Name, item2Name) {
        $scope.viewModel.fieldValueScoringList = [];
        configurationMediator.findUIFieldByUIFormTemplateUniqueNameAndFieldName(item1Name, item2Name).then((uiField) => {

            if (uiField.fieldTemplate.type === fieldType.LABEL || uiField.fieldTemplate.type === fieldType.SPACER ||
                uiField.fieldTemplate.type === fieldType.ROWREPEATER || uiField.fieldTemplate.type === fieldType.FUNCTION_BUTTON ||
                uiField.fieldTemplate.type === fieldType.LINK_BUTTON || uiField.fieldTemplate.type === fieldType.FORM_SUMMARY_GRID ||
                uiField.fieldTemplate.type === fieldType.TEXT_AREA) {
                $scope.viewModel.showInputFormField = false;
                $scope.viewModel.showRefresh = false;
                $rootScope.$broadcast(coreConstant.event.SHOW_FADING_NOTIFICATION, $scope.viewModel.inputFormFieldErrorMessage);
                $scope.viewModel.scoringRule.formTemplateUniqueName = '';
                $scope.viewModel.scoringRule.variableName = '';
                $rootScope.$broadcast(coreConstant.event.REFRESH_MULTI_SELECT, $scope.viewModel.scoringRule.formTemplateUniqueName, $scope.viewModel.scoringRule.variableName, $scope.viewModel.inputFormField);

            } else {
                if (isFieldWithoutValidatorAndDataset(uiField)
                    || uiField.fieldTemplate.validator === 'number'
                    || uiField.fieldTemplate.validator === 'percent'
                    || uiField.fieldTemplate.validator === 'currency'
                    || uiField.fieldTemplate.validator === 'number with commas'
                    || uiField.fieldTemplate.validator === 'number range') {
                    $scope.viewModel.showInputFormField = true;
                    $scope.fieldValidator = 'numberValidator';
                    $scope.viewModel.fieldValueScoringList.push(getEmptyObj());
                    $scope.viewModel.showRefresh = false;
                } else {
                    if (!_.isEmpty(uiField.fieldTemplate.dataSetName)) {
                        let dataSetParams = {name: uiField.fieldTemplate.dataSetName};
                        if (dataSetUtil.getDataSetType(dataSetParams.name) === dataSetType.REPEATING_FORM || dataSetUtil.getDataSetType(dataSetParams.name) === dataSetType.CUSTOM) {
                            $scope.viewModel.showInputFormField = true;
                            $scope.viewModel.showRefresh = false;
                            $scope.viewModel.fieldValueScoringList.push(getEmptyObj());
                        } else {
                            dataSetUtil.getDataSet(dataSetParams).then((result) => {
                                let fieldValue = {};
                                $scope.viewModel.showInputFormField = true;
                                $scope.viewModel.showRefresh = result.items.length > 0;

                                _.each(result.items, function (formula) {
                                    fieldValue = {};
                                    fieldValue.id = formula.id;
                                    fieldValue.value = !_.isNil(formula.value) ? formula.value : '';
                                    fieldValue.score = !_.isNil(formula.score) ? formula.score : '';
                                    if (_.isEmpty(String(fieldValue.value)) && _.isEmpty(String(fieldValue.score))) {
                                        fieldValue.isValid = false;
                                    } else if (!_.isEmpty(String(fieldValue.value)) && _.isEmpty(String(fieldValue.score))) {
                                        fieldValue.isValid = true;
                                    } else if (!_.isEmpty(String(fieldValue.value)) && (!_.isEmpty(String(fieldValue.score)))) {
                                        fieldValue.isValid = true;
                                    } else {
                                        fieldValue.isValid = false;
                                    }
                                    $scope.viewModel.formFieldDataSets.push(fieldValue);
                                });
                                $scope.viewModel.fieldValueScoringList.push(getEmptyObj());
                            });
                        }
                    } else {
                        let fieldValue = {};
                        $scope.viewModel.showRefresh = false;
                        if (uiField.fieldTemplate.type === fieldType.CHECK_BOX) {
                            $scope.viewModel.showInputFormField = true;
                            fieldValue = {};
                            fieldValue.value = _.get(translations, 'true');
                            fieldValue.score = '';
                            fieldValue.isValid = true;
                            $scope.viewModel.fieldValueScoringList.push(fieldValue);
                            fieldValue = {};
                            fieldValue.value = _.get(translations, 'false');
                            fieldValue.score = '';
                            fieldValue.isValid = true;
                            $scope.viewModel.fieldValueScoringList.push(fieldValue);
                            $scope.viewModel.fieldValueScoringList.push(getEmptyObj());
                        } else if (uiField.fieldTemplate.type === fieldType.YES_NO) {
                            $scope.viewModel.showInputFormField = true;
                            fieldValue = {};
                            fieldValue.value = _.get(translations, 'yes');
                            fieldValue.score = '';
                            fieldValue.isValid = true;
                            $scope.viewModel.fieldValueScoringList.push(fieldValue);
                            fieldValue = {};
                            fieldValue.value = _.get(translations, 'no');
                            fieldValue.score = '';
                            fieldValue.isValid = true;
                            $scope.viewModel.fieldValueScoringList.push(fieldValue);
                            $scope.viewModel.fieldValueScoringList.push(getEmptyObj());
                        } else {
                            $scope.viewModel.showInputFormField = true;
                            $scope.viewModel.fieldValueScoringList.push(getEmptyObj());
                        }
                    }
                    $scope.onItemChange();
                }
            }
        });
    }

    function isFieldWithoutValidatorAndDataset(uiField) {
        return _.isEmpty(uiField.fieldTemplate.dataSetName)
            && (_.isNil(uiField.fieldTemplate.validator)
                || uiField.fieldTemplate.validator === '[select]');
    }

    function getEmptyObj() {
        let emptyObj = {};
        emptyObj.value = '';
        emptyObj.score = '';
        emptyObj.min = '';
        emptyObj.max = '';
        emptyObj.isValid = true;
        return emptyObj;
    }

    function resetTriggerConditionForm() {
        $scope.viewModel.triggerFieldValue = '';
        $scope.viewModel.selectedOperator = '';
    }

    $scope.onRefreshClick = function () {
        if ($scope.viewModel.fieldValueScoringList.length === 1 && ($scope.viewModel.fieldValueScoringList[0].value === '' && $scope.viewModel.fieldValueScoringList[0].score === '')) {
            if ($scope.viewModel.populatedScoringFormulas.length === 0) {
                $scope.viewModel.fieldValueScoringList = _.map($scope.viewModel.formFieldDataSets, _.clone);
                $scope.viewModel.fieldValueScoringList.push(getEmptyObj());
            } else {
                $scope.viewModel.fieldValueScoringList = $scope.viewModel.populatedScoringFormulas;
                $scope.viewModel.fieldValueScoringList.push(getEmptyObj());
            }

        } else {
            let matchItems = [],
                gridItems = [];
            $scope.viewModel.populatedScoringFormulas = _.map($scope.viewModel.formFieldDataSets, _.clone);

            gridItems = _.map($scope.viewModel.fieldValueScoringList, _.clone);
            _.each(gridItems, function (item) {
                _.each($scope.viewModel.populatedScoringFormulas, function (scoringFormula) {
                    if (scoringFormula.value === item.value && scoringFormula.score === item.score) {
                        matchItems.push(item);
                    }
                });
            });
            _.remove(gridItems, function (fieldVal) {
                return fieldVal.value === '' && fieldVal.score === '';
            });

            if (matchItems.length === gridItems.length) {
                refreshGrid();
            } else {
                _.each($scope.viewModel.populatedScoringFormulas, function (scoringFormula) {
                    _.remove(gridItems, function (item) {
                        return scoringFormula.value === item.value && scoringFormula.score === item.score;
                    });

                });
                if (gridItems.length > 0) {
                    openRefreshModal(gridItems);
                }
            }
        }
        $scope.onItemChange();
    };

    function refreshGrid() {
        let populateScoringFormula = _.map($scope.viewModel.populatedScoringFormulas, _.clone);
        removeEmptyLastRows();
        _.each($scope.viewModel.fieldValueScoringList, function (item) {
            _.remove(populateScoringFormula, function (scoringFormula) {
                return (scoringFormula.value.toUpperCase() === item.value.toUpperCase() && scoringFormula.score === item.score);
            });
        });

        _.each(populateScoringFormula, function (formula) {
            $scope.viewModel.fieldValueScoringList.push(formula);
        });
        $scope.viewModel.fieldValueScoringList.sort(function (item1, item2) {
            let item1Value = item1.value.toUpperCase();
            let item2Value = item2.value.toUpperCase();
            if (item1Value < item2Value) {
                return -1;
            }
            if (item1Value > item2Value) {
                return 1;
            }
            return 0;
        });

        $scope.viewModel.scoringRule.formulas = _.map($scope.viewModel.fieldValueScoringList, _.clone);

        $scope.viewModel.fieldValueScoringList.push(getEmptyObj());
    }

    function openRefreshModal(filteredList) {
        let modalInstance = $uibModal.open({
            templateUrl: '/configuration/scoringRules/manageScoringRules/refreshModal.tpl.html',
            controller: 'refreshModalController',
            windowClass: 'refreshModal',
            resolve: {
                options: {
                    title: $scope.viewModel.warningLabel,
                    message: $scope.viewModel.warningMessage,
                    deleteAll: $scope.viewModel.deleteAll,
                    doNotDelete: $scope.viewModel.doNotDelete,
                    scoringFormulas: filteredList
                }
            }
        });

        modalInstance.result.then((result) => {
            if (!_.isNil(result)) {
                refreshGrid();
            } else {
                _.each(filteredList, function (item1) {
                    _.remove($scope.viewModel.fieldValueScoringList, function (item2) {
                        return item1.value === item2.value;
                    });
                });
                refreshGrid();
            }
        });
    }

    $scope.handleChange = function () {
        let triggerField = {triggerFieldValues: {triggerFieldValue: []}};
        //Category
        if (!_.isNil($scope.viewModel.selectedCategory)) {
            $scope.viewModel.scoringRule.scoringFolderName = $scope.viewModel.selectedCategory.name;
            if (!_.isInteger(parseInt($scope.viewModel.selectedCategory.value))) {
                $scope.viewModel.scoringRule.scoringFolderId = -1;
            } else {
                $scope.viewModel.scoringRule.scoringFolderId = $scope.viewModel.selectedCategory.value;
            }
        } else {
            $scope.viewModel.scoringRule.scoringFolderName = null;
            $scope.viewModel.scoringRule.scoringFolderId = null;
        }
        //trigger rule - Operator
        if (!_.isEmpty($scope.viewModel.selectedOperator)) {
            $scope.viewModel.scoringRule.triggerOperator = $scope.viewModel.selectedOperator.value;
        }
        // trigger rule - triggerFieldValue i.e Single Value
        if (!_.isEmpty($scope.viewModel.triggerFieldValue)) {
            if ($scope.viewModel.scoringRule.operator === 0) {
                _.each($scope.viewModel.triggerDataSetList, function (dataset) {
                    if (dataset.selected) {
                        $scope.viewModel.selectedDataSet.push(dataset);
                    }
                });
                triggerField.triggerFieldValues.triggerFieldValue = _.split($scope.viewModel.selectedDataSet, ',');
            } else {
                triggerField.triggerFieldValues.triggerFieldValue.push($scope.viewModel.triggerFieldValue);
            }
            $scope.viewModel.scoringRule.triggerFieldValue = xmlUtil.toXmlString(triggerField);
        } else if (!_.isEmpty($scope.viewModel.selectedTriggerDataSetValues) && _.isArray($scope.viewModel.selectedTriggerDataSetValues)) {

            triggerField.triggerFieldValues.triggerFieldValue = [];
            _.each($scope.viewModel.selectedTriggerDataSetValues, (dataItem) => {
                if (!_.isNil(dataItem)) {
                    if (_.isNil(dataItem.value)) {
                        triggerField.triggerFieldValues.triggerFieldValue.push(dataItem);
                    } else {
                        triggerField.triggerFieldValues.triggerFieldValue.push(dataItem.value);
                    }
                }

            });
            $scope.viewModel.scoringRule.triggerFieldValue = xmlUtil.toXmlString(triggerField);
        } else if (!_.isEmpty($scope.viewModel.selectedClassCodesValues)) {
            let classCodeArr = $scope.viewModel.selectedClassCodesValues.split(',');
            triggerField.triggerFieldValues.triggerFieldValue = [];
            if (classCodeArr.length > 1) {
                _.each(classCodeArr, (dataItem) => {
                    triggerField.triggerFieldValues.triggerFieldValue.push(dataItem);
                });
            } else {
                triggerField.triggerFieldValues.triggerFieldValue.push($scope.viewModel.selectedClassCodesValues);
            }
            $scope.viewModel.scoringRule.triggerFieldValue = xmlUtil.toXmlString(triggerField);
        } else {
            $scope.viewModel.scoringRule.triggerFieldValue = null;
        }
        if ($scope.viewModel.showApplyScoring === false) {
            $scope.viewModel.scoringRule.triggerOperator = null;
            $scope.viewModel.scoringRule.triggerFieldFormTemplateUniqueName = null;
            $scope.viewModel.scoringRule.triggerFieldVariableName = null;
            $scope.viewModel.scoringRule.triggerFieldValue = null;

        }

        if (_.isNil($scope.viewModel.scoringRule.formulas)) {
            fillScoringFormulasWithDataSet();
        }

        isScoringRuleValid();
        scoringRulesEditorModel.setUnsavedChanges($scope.viewModel.scoringRule.id, true);
    };

    let isScoringRuleValid = function () {
        let scoringRule = $scope.viewModel.scoringRule,
            isValid = true;
        if (_.isEmpty(scoringRule.name)) {
            isValid = false;
        } else if (_.isEmpty(scoringRule.scoringFolderName)) {
            isValid = false;
        } else if (_.isEmpty(scoringRule.effectiveDateRangeBegin)) {
            isValid = false;
        } else if ($scope.viewModel.showApplyScoring === true &&
            (_.isNaN(scoringRule.triggerOperator) || _.isEmpty(scoringRule.triggerFieldFormTemplateUniqueName) || _.isEmpty(scoringRule.triggerFieldVariableName) || _.isEmpty(scoringRule.triggerFieldValue))) {
            isValid = false;
        } else if (_.isEmpty(scoringRule.formTemplateUniqueName) || _.isEmpty(scoringRule.variableName)) {
            isValid = false;
        } else if ($scope.formulasValid === false) {
            isValid = false;
        }
        scoringRulesEditorModel.setValid(scoringRule.id, isValid);
    };

    $scope.handleApplyScoringChange = function () {
        resetTriggerConditionForm();
        $scope.viewModel.scoringRule.triggerFieldFormTemplateUniqueName = '';
        $scope.viewModel.scoringRule.triggerFieldVariableName = '';
        $timeout(function () {
            $rootScope.$broadcast(coreConstant.event.REFRESH_MULTI_SELECT, $scope.viewModel.scoringRule.triggerFieldFormTemplateUniqueName, $scope.viewModel.scoringRule.triggerFieldVariableName, $scope.viewModel.multiStepComponentName);
        }, 100);

        if ($scope.viewModel.applyScoring === 'OnConditionMet') {
            $scope.viewModel.showApplyScoring = true;
            $scope.viewModel.showClassCode = false;
        } else {
            $scope.viewModel.showApplyScoring = false;
        }
        $scope.handleChange();
    };

    $scope.isTriggerRuleValid = function () {
        if ($scope.viewModel.scoringRule) {
            if (!isValueExist($scope.viewModel.scoringRule.triggerFieldFormTemplateUniqueName) && !isValueExist($scope.viewModel.scoringRule.triggerFieldVariableName) && _.isNil($scope.viewModel.selectedOperator.name) && _.isEmpty($scope.viewModel.triggerFieldValue)) {
                return true;
            } else {
                if (isValueExist($scope.viewModel.scoringRule.triggerFieldFormTemplateUniqueName) &&
                    isValueExist($scope.viewModel.scoringRule.triggerFieldVariableName) &&
                    !_.isNil($scope.viewModel.selectedOperator.name)) {

                    if ($scope.viewModel.isDataSetField) {
                        if (!_.isEmpty($scope.viewModel.selectedTriggerDataSetValues) || !_.isEmpty($scope.viewModel.selectedClassCodesValues)) {
                            return true;
                        }
                    } else {
                        if (!_.isEmpty($scope.viewModel.triggerFieldValue)) {
                            return true;
                        }
                        if ($scope.viewModel.showClassCode) {
                            if (!_.isEmpty($scope.viewModel.selectedClassCodesValues)) {
                                return true;
                            }
                        }
                    }
                }
            }
            return false;
        } else {
            return true;
        }
    };

    $scope.handleClassCodeValueChange = function (classCodeValue) {
        $scope.viewModel.selectedClassCodesValues = classCodeValue;
        $scope.handleChange();
    };

    $scope.$on(coreConstant.event.MULTI_SELECT_UPDATED, function (event, itemName) {
        $scope.viewModel.selectedTriggerDataSetValues = [];
        if (itemName === $scope.viewModel.itemName) {
            _.each($scope.viewModel.triggerDataSetList, function (triggerDataSet) {
                if (triggerDataSet.selected) {
                    $scope.viewModel.selectedTriggerDataSetValues.push(triggerDataSet);
                }
            });
            $scope.handleChange();
        } else if (itemName === $scope.viewModel.multiStepComponentName) {
            $scope.handleChange();
        }
    });

    function isValueExist(val) {
        if (val && !_.isEmpty(val) && !_.isNil(val)) {
            return true;
        }
        return false;
    }

    $scope.$on('$destroy', function () {
        _.each(timeoutList, function (item) {
            $timeout.cancel(item);
        });
    });

    loadCategoryList();
};

angular.module('ums.configuration')
    .controller('manageScoringRulesController', ManageScoringRulesController);

